import axios, { AxiosRequestConfig } from "axios";

export type AlvysKeyStatus =
  | "not_configured"
  | "ok"
  | "expiring_soon"
  | "expired"
  | "rejected";

export interface AlvysSecret {
  configured: boolean;
  last4: string;
}

export interface AlvysConnection {
  available: boolean;
  enabled: boolean;
  can_manage: boolean;
  client_id: string;
  client_secret: AlvysSecret;
  webhook_secret: AlvysSecret;
  key_expires_on: string | null;
  key_status: AlvysKeyStatus;
  key_rejected_at: string | null;
  webhook_url: string;
  webhook_events: string[];
  last_event_at: string | null;
  recent_failures: number;
}

export interface AlvysConnectionUpdate {
  enabled?: boolean;
  client_id?: string;
  client_secret?: string;
  webhook_secret?: string;
  key_expires_on?: string | null;
}

const getAlvysConnection = async (
  factoringId: string
): Promise<AlvysConnection> => {
  const options: AxiosRequestConfig = {
    url: `/factoring/${factoringId}/alvys/`,
    method: "GET"
  };
  const response = await axios(options);
  return response.data;
};

const updateAlvysConnection = async (
  factoringId: string,
  data: AlvysConnectionUpdate
): Promise<AlvysConnection> => {
  const options: AxiosRequestConfig = {
    url: `/factoring/${factoringId}/alvys/`,
    method: "PUT",
    data
  };
  const response = await axios(options);
  return response.data;
};

const removeAlvysConnection = async (
  factoringId: string
): Promise<AlvysConnection> => {
  const options: AxiosRequestConfig = {
    url: `/factoring/${factoringId}/alvys/`,
    method: "DELETE"
  };
  const response = await axios(options);
  return response.data;
};

export default {
  getAlvysConnection,
  updateAlvysConnection,
  removeAlvysConnection
};
